module.exports = __webpack_public_path__ + "static/media/payment-method.4d913d59.svg";